import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class VisualisationMcpParametrageResolverService  {

  resolve = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<number> | Promise<number> | number => {
    let idUdpMdp: number = +route.paramMap.get('idUdpMcp');
    return idUdpMdp;
  };

}

